module.exports = __webpack_public_path__ + "img/EQLI.c5b12bfd.svg";